import { gql } from '@apollo/client';

export const ADDRESS_ALIAS_LIST = gql`
  query AddressAliasList(
    $addressId: Long
    $aliasName: String
    $fullAddress: String
    $page: Int!
    $size: Int!
  ) {
    addressAliasList(
      addressId: $addressId
      aliasName: $aliasName
      fullAddress: $fullAddress
      page: $page
      size: $size
    ) {
      content {
        id
        addressId
        aliasName
        aliasType
        aliasFullAddress
        similarityScore
        source
        standardizedFullAddress
        createdAt
        updatedAt
      }
      page
      size
      totalElements
      totalPages
      hasNext
      hasPrevious
    }
  }
`;

export const DELETE_ADDRESS_ALIAS = gql`
  mutation DeleteAddressAlias($id: Long!) {
    deleteAddressAlias(id: $id)
  }
`;

export const BATCH_DELETE_ADDRESS_ALIAS = gql`
  mutation BatchDeleteAddressAlias($ids: [Long!]!) {
    batchDeleteAddressAlias(ids: $ids)
  }
`;

export interface AddressAliasInfo {
  id: string;
  addressId: number;
  aliasName: string;
  aliasType: string;
  aliasFullAddress: string;
  similarityScore: string | number | null;
  source: string | null;
  standardizedFullAddress: string | null;
  createdAt: string | null;
  updatedAt: string | null;
}

export interface AddressAliasPageResponse {
  content: AddressAliasInfo[];
  page: number;
  size: number;
  totalElements: number;
  totalPages: number;
  hasNext: boolean;
  hasPrevious: boolean;
}

export interface AddressAliasListResponse {
  addressAliasList: AddressAliasPageResponse;
}
